import { FirstToFileFeatureFlags, FIRST_TO_FILE_WIDGET_FEATURE_FLAG_KEYS } from '@model/widget.model';
import { createReducer, on } from '@ngrx/store';

import { setFeatureFlags, setLoaded } from '../actions/feature-flags.actions';

export interface FeatureFlagState {
  flags: FirstToFileFeatureFlags;
  isLoaded: boolean;
}

/**
 * The initial state for the feature flags.
 */
export const initialFeatureFlagsState: FeatureFlagState = {
  flags: FIRST_TO_FILE_WIDGET_FEATURE_FLAG_KEYS.reduce((acc, key) => {
    acc[key] = true;
    return acc;
  }, {} as FirstToFileFeatureFlags),
  isLoaded: false,
};

/**
 * The reducer function for the feature flags.
 */
export const featureFlagsReducer = createReducer(
  initialFeatureFlagsState,
  on(setFeatureFlags, (state, { featureFlags }) => ({ ...state, ...{ flags: featureFlags }, isLoaded: true })),
  on(setLoaded, (state, { isLoaded }) => ({ ...state, isLoaded }))
);
